import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { TextButton } from '@frontend/design-system';

type SeeMoreOrLessButtonProps = {
  onClick: () => void;
  isSelected?: boolean;
};

export const SeeMoreOrLessButton = ({ onClick, isSelected = false, ...rest }: SeeMoreOrLessButtonProps) => {
  const { t } = useTranslation('insuranceEligibilityReport');

  return (
    <TextButton css={buttonStyle} onClick={onClick} {...rest}>
      {isSelected ? t('See Less') : t('See More')}
    </TextButton>
  );
};

const buttonStyle = css`
  font-size: ${theme.fontSize(16)};
  font-weight: ${theme.font.weight.bold};
  color: ${theme.colors.primary50};
  height: fit-content;

  @media print {
    display: none;
  }
`;
